<template>
  <div>
    <Card shadow>
      <Row :gutter="18">
        <Col span="7" style="display:none">
          <label style="display: flex; align-items: center">
            <span style="width: 80px">代理组:</span>
            <Select
              v-model="table.params.platid"
              filterable
              placeholder="选择APP分组"
              clearable
            >
              <Option
                v-for="(item, index) in plat_list"
                :value="item.id"
                :label="item.name"
                :key="index"
              >
                {{ item.name }}
                <span style="color: #bbb">({{ item.id }})</span>
              </Option>
            </Select>
          </label>
        </Col>
        <Col span="3">
          <label style="display: flex; align-items: center">
            <span style="width: 50px">代理:</span>
            <Select
              v-model="table.params.app_id"
              :disabled="!table.params.platid"
              filterable
              placeholder="选择APP盘口"
              clearable
            >
              <Option
                v-for="(item, index) in app_list.filter(
                  item => item.platform == table.params.platid
                )"
                :value="item.appid"
                :label="item.appName"
                :key="index"
              >
                {{ item.appName }}
                <span style="color: #bbb">({{ item.appid }})</span>
              </Option>
            </Select>
          </label>
        </Col>
        <Col span="4">
          <label style="display: flex; align-items: center">
            <span style="width: 120px">筛选游戏:</span>
            <Select
              v-model="table.params.game_id"
              filterable
              clearable
              placeholder="下拉筛选游戏"
            >
              <Option
                v-for="(item, index) in select.game_list"
                :value="item.game_id"
                :label="item.game_name"
                :key="index"
              >
                {{ item.game_name }}
              </Option>
            </Select>
          </label>
        </Col>
        <Col span="4">
          <label style="display: flex; align-items: center">
            <span style="width: 140px">玩家ID:</span>
            <Input v-model.trim="table.params.uid" placeholder="玩家ID" />
          </label>
        </Col>
        <Col span="4">
          <label style="display: flex; align-items: center">
            <span style="width: 140px">筛选时间:</span>
            <DatePicker
              type="date"
              v-model="select.dataTime"
              placement="bottom-end"
              placeholder="筛选时间"
              style="width: 100%"
              :options="dateOptions"
            ></DatePicker>
          </label>
        </Col>
        <Button
          type="primary"
          :size="isMOble() ? 'small' : 'default'"
          @click="getList"
          :disabled="
            !table.params.platid ||
              !table.params.app_id ||
              !table.params.uid ||
              !table.params.game_id
          "
          >查询</Button
        >
        <span style="margin-left: 10px">总局数:{{ table.total }}</span
        ><span style="margin-left: 10px">总匹配人数:{{ table.count }}</span>
      </Row>
    </Card>
    <Table border :columns="table.columns" :data="table.data"></Table>
  </div>
</template>
<script>
import { TransTopReq, GetAllGameList } from '@/api/admin/risk'
export default {
  name: 'pvpInquire',
  data() {
    return {
      select: {
        game_list: [],
        dataTime: new Date()
      },
      dateOptions: {
        disabledDate(date) {
          return date && date.valueOf() > Date.now()
        }
      },
      //表单数据
      table: {
        total: 0,
        count: 0,
        params: {
          platid: 0,
          app_id: -1,
          game_id: 0,
          stime: 10,
          uid: ''
        },
        data: [],
        columns: [
          { type: 'index', title: '序号', width: 50, align: 'center' },
          {
            title: '盘口信息',
            key: 'tag',
            minWidth: 100,
            align: 'center',
            render: (h, params) => {
              let app_info = this.getAppInfo(params.row)
              return h('div', [
                h('span', app_info.appName || ''),
                h(
                  'span',
                  { style: 'color:#bbb;' },
                  `（${app_info.appid || ''}）`
                )
              ])
            }
          },
          { key: 'count', title: '游戏局数', minWidth: 80, align: 'center' },
          { key: 'uid', align: 'center', minWidth: 80, title: '匹配ID' },
          {
            key: 'match_rate',
            align: 'center',
            minWidth: 80,
            title: '匹配率',
            render: (h, params) =>
              h('span', params.row.match_rate.toFixed(2) + '%')
          }
        ]
      }
    }
  },
  methods: {
    GetAllGameList() {
      GetAllGameList({ gtype: 0, page: 1, page_size: 10000 }).then(res => {
        let list = res._param.data || []
        this.select.game_list = list.filter(item => item.gtype == 2)
      })
    },
    getList() {
      let params = {
        mod: 'root',
        platid: this.table.params.platid,
        app_id: this.table.params.app_id,
        param: {
          _mod: 'root',
          _func: 'QueryUserGameData',
          _param: {
            ...this.table.params,
            stime: this.getSecond(this.select.dataTime),
            uid: Number(this.table.params.uid)
          }
        }
      }
      TransTopReq(params).then(res => {
        this.table.data = res['_param'].data || []
        this.table.total = res['_param'].total || 0
        this.table.count = res['_param'].count || 0
        // this.table.total = res["_param"].total;
      })
    },
    initFunc() {
      this.table.params.platid = this.getinitPlatId()
      // this.table.params.app_id = this.app_list.find(
      //   item => item.platform == this.table.params.platid
      // ).appid
      // this.getList()
    },
    getAppInfo(el) {
      return this.app_list.find(item => item.appid == el.app_id) || {}
    }
  },

  created() {
    this.initFunc()
    this.GetAllGameList()
  }
}
</script>

<style lang="less" scoped>
.btn_batch {
  margin-right: 12px;
}
</style>
